"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableList = void 0;
var React = require("react");
var headersList_1 = require("./headersList");
var rowsList_1 = require("./rowsList");
var buttons_1 = require("../buttons");
var bulkEdit_1 = require("./bulkEdit");
var typestyle_1 = require("typestyle");
var mobx_react_1 = require("mobx-react");
var config_1 = require("../../config");
var quickAdd_1 = require("./quickAdd");
var EditableList = (function (_super) {
    __extends(EditableList, _super);
    function EditableList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            editing: false,
            quickadding: false,
            settings: false,
            selectedRowIds: [],
            allRowIds: props.rows.map(function (row) { return row.id; }),
        };
        return _this;
    }
    EditableList.prototype.componentWillReceiveProps = function (props) {
        this.setState({
            allRowIds: props.rows.map(function (row) { return row.id; }),
        });
        setTimeout(this.resizeHeight.bind(this)(), 1000);
    };
    EditableList.prototype.componentDidMount = function () {
        setTimeout(this.resizeHeight.bind(this)(), 1000);
        $(window).resize(this.resizeHeight.bind(this));
    };
    EditableList.prototype.toggleBulkEdit = function () {
        if (this.props.allowBulkEditing) {
            if (!this.state.quickadding) {
                $('.EditableList__Container').toggleClass('EditableList__Container--bulk');
                $('.EditableList__TableContainer').toggleClass('EditableList__TableContainer--bulk');
            }
            this.setState(function (nextState) {
                return {
                    editing: !nextState.editing,
                    quickadding: false,
                    selectedRowIds: [],
                };
            });
        }
    };
    EditableList.prototype.toggleQuickAdd = function () {
        if (this.props.allowQuickAdd) {
            if (!this.state.editing) {
                $('.EditableList__Container').toggleClass('EditableList__Container--bulk');
                $('.EditableList__TableContainer').toggleClass('EditableList__TableContainer--bulk');
            }
            this.setState(function (nextState) {
                return {
                    editing: false,
                    quickadding: !nextState.quickadding,
                    selectedRowIds: [],
                };
            });
        }
    };
    EditableList.prototype.onSelectRow = function (row, isSelected) {
        var selected = this.state.selectedRowIds.slice();
        if (isSelected) {
            var alreadyInList = selected.filter(function (id_) { return id_ == row.id; }).length === 1;
            if (!alreadyInList)
                selected.push(row.id);
        }
        else {
            selected = selected.filter(function (id_) { return id_ !== row.id; });
        }
        this.setState({
            selectedRowIds: selected,
        });
    };
    EditableList.prototype.areAllRowsSelected = function () {
        return this.state.selectedRowIds.length >= this.state.allRowIds.length;
    };
    EditableList.prototype.onSelectAllRows = function () {
        if (this.areAllRowsSelected())
            this.setState({
                selectedRowIds: [],
            });
        else
            this.setState({
                selectedRowIds: this.state.allRowIds.slice(),
            });
    };
    EditableList.prototype.isRowSelected = function (row) {
        return this.state.selectedRowIds.filter(function (id_) { return id_ == row.id; }).length === 1;
    };
    EditableList.prototype.performBulkUpdate = function (values) {
        return this.props.performBulkUpdate(this.state.selectedRowIds.map(function (row_id) { return row_id; }), values);
    };
    EditableList.prototype.resizeHeight = function () {
        if (this.props.disableResizeToPage)
            return;
        var a = $(".EditableList__TableContainer");
        var paginatorHeight = 81;
        var filtersHeight = $(".toolbarCollapsible").outerHeight();
        var newHeight = $(window).outerHeight()
            - a.offset().top
            - paginatorHeight
            + filtersHeight;
        a.height(Math.max(newHeight, 400));
    };
    EditableList.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var editContainer = 'EditableList__Container';
        var editContainerBulk = 'EditableList__Container--bulk';
        var editableTableContainer = 'EditableList__TableContainer';
        var editableTableContainerBulk = 'EditableList__TableContainer--bulk';
        var editableList = 'EditableList table table-bordered';
        var editableListFixed = 'EditableList--fixed';
        return (React.createElement("div", { className: "EditableList__Content" },
            props.allowBulkEditing && (React.createElement(buttons_1.PrimaryButton, { id: "EditableList__BulkButtonId", onClick: function (e) { return _this.toggleBulkEdit(); } })),
            props.allowQuickAdd && (React.createElement(buttons_1.PrimaryButton, { id: "EditableList__QuickAddButtonId", onClick: function (e) { return _this.toggleQuickAdd(); } })),
            React.createElement("div", { className: (0, typestyle_1.classes)(editContainer, (this.state.editing || this.state.quickadding) && editContainerBulk) },
                React.createElement("div", { className: (0, typestyle_1.classes)(editableTableContainer, (this.state.editing || this.state.quickadding) && editableTableContainerBulk) }, props.rows.length > 0 ?
                    (0, config_1.groupBy)(props.rows, function (row) { return row.group_key; }).map(function (group) {
                        return (React.createElement(React.Fragment, null,
                            group.key && React.createElement("h2", { className: "EditableList__GroupTitle" }, group.key),
                            React.createElement("table", { className: (0, typestyle_1.classes)(editableList, _this.state.editing && editableListFixed) },
                                React.createElement(headersList_1.default, { columns: props.columns, headers: props.headers, inBulkEditMode: props.allowBulkEditing && _this.state.editing, areAllRowsSelected: _this.areAllRowsSelected.bind(_this), onClickSelectHeader: _this.onSelectAllRows.bind(_this), onClickSortHeader: props.headerSortClickHandler }),
                                React.createElement(rowsList_1.default, { columns: props.columns, rows: group.members, onClickLink: props.rowClickHandler, inBulkEditMode: props.allowBulkEditing && _this.state.editing, onRowSelected: _this.onSelectRow.bind(_this), isRowSelected: _this.isRowSelected.bind(_this), performRowUpdate: props.performRowUpdate, refetchTable: _this.props.refetchTable, relationProps: _this.props.relationProps }))));
                    })
                    :
                        React.createElement("table", { className: (0, typestyle_1.classes)(editableList) },
                            React.createElement(headersList_1.default, { columns: props.columns, headers: props.headers, inBulkEditMode: false, onClickSortHeader: props.headerSortClickHandler }))),
                props.allowBulkEditing && this.state.editing && (React.createElement("div", { className: "EditableList__BulkMenuContainer" },
                    React.createElement(bulkEdit_1.BulkEditMenu, { fields: props.bulkEditFields, performBulkUpdate: this.props.performBulkUpdate && this.performBulkUpdate.bind(this), refetchTable: this.props.refetchTable, toggleEdit: this.toggleBulkEdit.bind(this), selectedRowIds: this.state.selectedRowIds, updateBulkMenuState: props.updateBulkMenuState, bulkMenuState: props.bulkMenuState }))),
                props.allowQuickAdd && this.state.quickadding && (React.createElement("div", { className: "EditableList__BulkMenuContainer" },
                    React.createElement(quickAdd_1.QuickAddMenu, { fields: props.quickEditFields, performQuickAdd: this.props.performQuickAdd && this.props.performQuickAdd.bind(this), refetchTable: this.props.refetchTable, toggleQuickAdd: this.toggleQuickAdd.bind(this), quickAddMenuState: props.quickAddMenuState }))))));
    };
    EditableList = __decorate([
        mobx_react_1.observer
    ], EditableList);
    return EditableList;
}(React.Component));
exports.EditableList = EditableList;
